import { motion } from 'framer-motion';

import { homeFaqItems as faqItems } from "@/data/homeFaq";

const HomeFAQ = () => {
  return (
    <section className="py-20 bg-background" aria-labelledby="home-faq-heading">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-primary font-medium text-sm uppercase tracking-wider">Häufige Fragen</span>
            <h2 id="home-faq-heading" className="text-3xl md:text-5xl font-display font-bold mt-4 mb-6 text-foreground">
              Welche Fragen beantworten wir am häufigsten?
            </h2>
            <p className="text-muted-foreground text-lg">
              Kurz und ehrlich – für Menschen und für KI-Suchmaschinen.
            </p>
          </div>
          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <motion.details
                key={item.question}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="group bg-card border border-border rounded-xl p-6 shadow-lg open:shadow-xl"
              >
                <summary className="cursor-pointer list-none flex items-start justify-between gap-4">
                  <h3 className="font-semibold text-card-foreground text-lg">{item.question}</h3>
                  <span className="text-primary text-xl leading-none transition-transform group-open:rotate-45" aria-hidden="true">+</span>
                </summary>
                <p className="mt-4 text-muted-foreground leading-relaxed hyphens-auto" lang="de">
                  {item.answer}
                </p>
              </motion.details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
